export default {"src":"/_next/static/media/search.59819ef0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};